// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--R2bpz","footerSocialList":"footer-module--footer-social-list--1bcct","footerItem":"footer-module--footer-item--ErweO"};